import { sha256 } from "js-sha256";
import personApis from "@/api/modules/person";
import { Loading } from "element-ui";
/*
 * @Description: 公共的工具类
 * @version:
 * @Author: ywl
 * @Date: 2021-08-04 18:54:26
 * @LastEditors: shirley 1040698446@qq.com
 * @LastEditTime: 2023-04-04 11:42:08
 */
/**
 * 抽象类
 */
import Cookies from "js-cookie";
export interface ToolInterface {
  /**
   * @description: 测试
   * @param {*} params
   * @return {*}
   */
  test(params: any): any;

  /**
   * 格式化日期
   */
  getDateTime(timestamp: any, format: any): any;
  /**
   * AES 加密
   * @param params
   */
  encrypt(params: any): any;

  /**
   * AES 解密
   * @param params
   */
  decrypt(params: any): any;
  /**
   * 设置cookies
   * @param params
   */
  setCookie(cname: any, cvalue: any, exdays: any, domain?: string): any;
  /**
   * 获取cookies
   * @param params
   */
  getCookie(cname: any): any;
  /**
   * 删除cookies
   * @param params
   */
  deleteCookie(cname: any, domain?: string): any;
  /**
   * 去掉所有的html标记
   * @param params
   */
  secondToTime(second: any): any;
  /**
   * 去掉所有的html标记
   * @param params
   */
  highlight(cname: any): any;
  /**
   * 返回文字描述的日期
   * @param date
   */
  getTimeFormatText(date: any): any;
  /**
   *
   * @param str 需要操作的字符串
   * @param len1 开头不需要变成星号的长度
   * @param len2 末尾不需要变成星号的长度，设置默认值为0
   */
  changeToStar(str: any, len1: any, len2: any): any;
  /**
   *
   * @param fileUrl 图片链接
   * @param voteId 活动id 可不传
   */
  rotatePicture(fileUrl: string, voteId?: string): any;
  /**
   *
   * @param data 答案数据
   */
  processingSubjectData(data: any): any;
  getNonce(length: any): any;
  ShaGeneratesignature(timestamp: number, nonce: string): any;
  getImageParam(url: any): any;
  processArticleDetail(html: string): string;
}

const keyOne = "huodongce2021096"; // 秘钥
// const keyOne = window.atob('aHVvZG9uZ2NlMjAyMTA5Ng==')  //  先window.btoa加密，后用window.atob解密 'huodongce2021096'; // 秘钥
// const CryptoTS = require("crypto-ts");
import * as CryptoTS from "crypto-ts";
import { mixin } from "vue/types/umd";
export class Tool implements ToolInterface {
  // secondToTime(second: any) {
  //   throw new Error("Method not implemented.");
  // }
  // highlight(cname: any) {
  //   throw new Error("Method not implemented.");
  // }

  public test(item: any) {
    return item;
  }

  /**
   * 格式化日期
   * @param val
   * @param format
   * @returns
   */
  public getDateTime(val: any, format: any) {
    let timestamp = val;
    if (!timestamp) {
      return "";
    }
    if ((val + "").length === 10) {
      timestamp = parseFloat(val) * 1000;
    }
    const pad = (val1: any) => {
      val1 = String(val1);
      while (val1.length < 2) {
        val1 = "0" + val1;
      }
      return val1;
    };
    const date = new Date(parseFloat(timestamp));
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hour = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const second = pad(date.getSeconds());
    const milliseconds = pad(date.getMilliseconds());
    switch (format) {
      case "MM-DD HH:MM:SS":
        return [month, day].join("-") + " " + [hour, minutes, second].join(":");
      case "YYYY-MM-DD HH:MM":
        return [year, month, day].join("-") + " " + [hour, minutes].join(":");
      case "date":
        return [year, month, day].join("-");
      case "YYYY-MM-DD":
        return [year, month, day].join("-");
      case "time":
        return [hour, minutes, second].join(":");
      case "HH:MM:SS":
        return [hour, minutes, second].join(":");
      case "HH:MM":
        return [hour, minutes].join(":");
      case "YYYYMMDD":
        return year + month + day;
      case "YYYY.MM.DD":
        return [year, month, day].join(".");
      case "array":
        return [year, month, day, hour, minutes, second];
      case "full":
        return (
          [year, month, day].join("-") + " " + [hour, minutes, second].join(":")
        );
      case "YYYY-MM-DD HH:MM:SS":
        return (
          [year, month, day].join("-") + " " + [hour, minutes, second].join(":")
        );
      case "YYYY年MM月DD日 HH时MM分":
        return (
          year +
          "年" +
          month +
          "月" +
          day +
          "日" +
          " " +
          hour +
          "时" +
          minutes +
          "分"
        );
      case "number":
        return [year + month + day + hour + minutes + second + milliseconds];
      default:
        return [month, day].join("-") + " " + [hour, minutes, second].join(":");
    }
  }
  /**
   * AES 加密
   * @param params
   * @returns
   */
  public encrypt(params: any) {
    const key = CryptoTS.enc.Utf8.parse(keyOne);
    const srcs = CryptoTS.enc.Utf8.parse(params);
    const encrypted = CryptoTS.AES.encrypt(srcs, key, {
      mode: CryptoTS.mode.ECB,
      padding: CryptoTS.pad.PKCS7,
    });
    return encrypted.toString();
  }
  /**
   * AES 解密
   * @param params
   * @returns
   */
  public decrypt(params: any) {
    const key = CryptoTS.enc.Utf8.parse(keyOne);
    const decrypt = CryptoTS.AES.decrypt(params, key, {
      mode: CryptoTS.mode.ECB,
      padding: CryptoTS.pad.PKCS7,
    });
    return CryptoTS.enc.Utf8.stringify(decrypt).toString();
  }
  /**
   * 保存cookies
   * @param cname
   * @param cvalue
   * @param exdays
   * @returns
   */
  public setCookie(cname: any, cvalue: any, exdays: any, domain?: any) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "; expires=" + d.toUTCString();
    const domains = "; domain=" + domain; // 设置域名
    // console.log(cname + "=" + cvalue + domains +  expires)
    document.cookie = cname + "=" + cvalue + domains + expires + ";path=/";
  }
  /**
   * 获取cookies
   * @param cname
   * @returns
   */
  public getCookie(cname: any) {
    const name = cname + "=";
    const ca = document.cookie.split(";");
    for (const index of Object.keys(ca)) {
      let c = ca[Number(index)];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) !== -1) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  /**
   * 删除cookies
   * @param cname
   * @returns
   */
  public deleteCookie(cname: any, domain?: string) {
    const domains = ";domain=" + domain; // 设置域名
    document.cookie =
      cname + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT" + domains;
    Cookies.remove("cname", { expires: -1, domain: domain });
  }
  /**
   * 秒数转为时分秒
   * @param cname
   * @returns
   */
  public secondToTime(second: any) {
    const days = Math.floor(second / (60 * 60 * 24));
    const hours = Math.floor((second % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((second % (60 * 60)) / 60);
    const seconds = Math.floor(second % 60);
    if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
      return { seconds: "0" };
    } else if (days === 0 && hours === 0 && minutes === 0) {
      return { seconds };
    } else if (days === 0 && hours === 0) {
      return { minutes, seconds };
    } else if (days === 0) {
      return { hours, minutes, seconds };
    } else {
      return { days, hours, minutes, seconds };
    }
  }
  /**
   * 去掉所有的html标记
   * @param name
   * @returns
   */
  public highlight(name: any) {
    // console.log(name)
    if (name) {
      const str = name
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&quot;/gi, `"`)
        .replace(" ", "")
        .replace("&#39;", "'")
        .replace(/&gt;/gi, "<");
      return str;
    }
    return null;
  }
  /**
   * 返回文字描述的日期
   * @param name
   * @returns
   */
  public getTimeFormatText(date: any) {
    if (date == null) {
      return null;
    }

    const minute: number = 60 * 1000; // 1分钟
    const hour: number = 60 * minute; // 1小时
    const day: number = 24 * hour; // 1天
    // const month: number = 31 * day; // 月
    // const year: number = 12 * month; // 年
    const diff: number = new Date().getTime() - date;
    let r = 0;

    if (diff > day) {
      if (diff / day > 7) {
        return "7天前";
      } else {
        r = Math.floor(diff / day);
        return r + "天前";
      }
    }
    if (diff > hour) {
      r = Math.floor(diff / hour);
      return r + "小时前";
    }
    if (diff > minute) {
      r = Math.floor(diff / minute);
      return r + "分钟前";
    }
    return "刚刚";
  }
  /**
   * 字符串中间替换成星号
   * @param str 需要操作的字符串
   * @param len1 开头不需要变成星号的长度
   * @param len2 末尾不需要变成星号的长度，设置默认值为0，不传的时候就除了设置的开头几位剩余全部变成星号。
   * @returns
   */
  public changeToStar(str: any, len1: any, len2 = 0) {
    const strLen = str.length;
    let stars = "";
    for (let i = 0; i < strLen - len1 - len2; i++) {
      stars += "*";
    }
    str = str.substr(0, len1) + stars + str.substr(strLen - len2);
    return str;
  }
  public dataURLtoBlob(dataurl: any) {
    const arr: any = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }
  // rotatePicture 旋转图片并返回图片链接
  public rotatePicture(fileUrl: string, voteId?: string) {
    return new Promise((resolve, reject) => {
      let loadingInstance = Loading.service({ body: true });
      const img = new Image();
      img.src = fileUrl;
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        const canvas: any = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        canvas.width = img.height;
        canvas.height = img.width;
        // 旋转图片90度
        // 旋转前，先将绘制原点（0,0）移动到画布的中心
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(img, -img.width / 2, -img.height / 2);
        const base64Image = canvas.toDataURL("image/png", 1);

        const blob = this.dataURLtoBlob(base64Image);
        const formData = new FormData();
        if (voteId) formData.append("voteId", voteId);
        formData.append("file", blob, "image.png");
        // 图片上传
        personApis
          .imageUploadApi(formData)
          .then((imgres: any) => {
            resolve(imgres);
            loadingInstance.close();
          })
          .catch((err: any) => {
            reject(err);
            loadingInstance.close();
          });
      };
    });
  }
  public getFileType(format: string) {
    let type = "";
    switch (format) {
      case "png":
      case "jpg":
      case "gif":
      case "bmp":
        type = "image";
        break;
      case "mp4":
      case "flv":
      case "wmv":
      case "3gp":
      case "avi":
        type = "video";
        break;
      case "mp3":
      case "wma":
      case "wav":
      case "amr":
      case "m4a":
      case "aac":
        type = "audio";
        break;
      default:
        type = "file";
        break;
    }
    return type;
  }
  // 处理返回的答案数据，变回统一格式用于在表格显示
  public processingSubjectData(data: any) {
    let returnData: any = {};
    data.forEach((e: any) => {
      let answer: any = [];
      let answerContent: any = "";
      let answerObj: any = {};
      switch (e[0].subjectType) {
        // 单项选择题，下拉题，单项填空题，简答题，打分题，量表题，NPS，签名,日期
        case 1:
        case 6:
        case 7:
        case 14:
        case 21:
        case 26:
        case 27:
        case 37:
          returnData[e[0].subjectId] = {
            subjectType: e[0].subjectType,
            answerContent: e[0].answerJson.answerContent,
          };
          break;
        // 多项选择题，级联题，横向填空题，时间，自增表格，矩阵选择，矩阵填空，矩阵打分
        case 2:
        case 4:
        case 9:
        case 10:
        case 11:
        case 12:
        case 20:
        case 25:
          answer.length = 0;
          answerContent = "";
          e.forEach((item: any) => {
            answer.push(item.answerJson.answerContent);
          });
          if (e[0].subjectType == 4) {
            answerContent = answer.join("  ");
          } else if (e[0].subjectType == 20) {
            answerContent = answer.join(":");
          } else {
            answerContent = answer.join("，");
          }
          returnData[e[0].subjectId] = {
            subjectType: e[0].subjectType,
            answerContent,
          };
          break;
        // 图片选择题，下拉题
        case 3:
        case 5:
          if (e.length == 1) {
            returnData[e[0].subjectId] = {
              subjectType: e[0].subjectType,
              answerContent: e[0].answerJson.answerContent,
            };
          } else if (e.length >= 2) {
            let answer: any = [];
            e.forEach((item: any) => {
              answer.push(item.answerJson.answerContent);
            });
            returnData[e[0].subjectId] = {
              subjectType: e[0].subjectType,
              answerContent: answer.join("，"),
            };
          }
          break;
        // 多项填空题
        case 8:
          answer.length = 0;
          e.forEach((item: any) => {
            answer.push(
              item.answerJson.optionTitle + "：" + item.answerJson.answerContent
            );
          });
          returnData[e[0].subjectId] = {
            subjectType: e[0].subjectType,
            answerContent: answer.join("，"),
          };
          break;
        // 文件上传
        case 13:
          answer.length = 0;
          e.forEach((item: any) => {
            if ("fileName" in item.answerJson) {
              let format = item.answerJson.answerContent
                .slice(item.answerJson.answerContent.lastIndexOf(".") + 1)
                .toLowerCase();
              answer.push({
                fileName: item.answerJson.answerContent,
                fileIndex: item.answerJson.fileIndex,
                fileType: this.getFileType(format),
                fileUrl: "",
              });
            }
          });
          e.forEach((item: any) => {
            if ("fileUrl" in item.answerJson) {
              if (answer[item.answerJson.fileIndex - 1]) {
                answer[item.answerJson.fileIndex - 1].fileUrl =
                  item.answerJson.answerContent;
              }
            }
          });
          returnData[e[0].subjectId] = {
            subjectType: e[0].subjectType,
            answerContent: answer,
          };
          break;
        // 地址
        case 17:
          answer.length = 0;
          e.forEach((item: any) => {
            if (item.answerJson.answerContent.indexOf("_") >= 0) {
              answer.push(item.answerJson.answerContent.split("_")[1]);
            } else {
              answer.push(item.answerJson.answerContent);
            }
          });
          returnData[e[0].subjectId] = {
            subjectType: e[0].subjectType,
            answerContent: answer.join(" "),
          };
          break;
        // 排序
        case 33:
          answer.length = 0;
          e.forEach((item: any) => {
            answer.unshift(
              item.answerJson.answerContent + "." + item.answerJson.optionTitle
            );
          });
          returnData[e[0].subjectId] = {
            subjectType: e[0].subjectType,
            answerContent: answer.join("，"),
          };
          break;
        // 地理位置
        case 18:
          returnData[e[2].subjectId] = {
            subjectType: e[2].subjectType,
            answerContent: e[2].answerJson.answerContent,
          };
          break;
        // 评价题
        case 38:
          answerObj = { label: [] };
          e.forEach((item: any) => {
            if (item.answerJson.evaluateType == 2) {
              answerObj.label.push(item.answerJson.labelTitle);
            }
            if (item.answerJson.evaluateType == 1) {
              answerObj.score = item.answerJson.answerContent;
            }
            if (item.answerJson.evaluateType == 3) {
              answerObj.content = item.answerJson.answerContent;
            }
          });
          returnData[e[0].subjectId] = {
            subjectType: e[0].subjectType,
            answerContent:
              answerObj.score +
              (answerObj.label.length > 0 ? "；" : "") +
              answerObj.label.join("，") +
              (answerObj.content ? "；" : "") +
              answerObj.content,
          };
          break;
        default:
          break;
      }
    });
    return returnData;
  }
  // 随机生成字符串
  public getNonce(length: number) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  public ShaGeneratesignature(timestamp: number, nonce: string) {
    const secret = "LongYiXiu";
    const item = timestamp + nonce + secret;
    // console.log(item);
    return sha256(item);
  }
  /**
   *
   * @param url
   * @returns
   */
  public getImageParam(url: any) {
    const formatNumber = (num: number) => {
      return num >= 10 ? num + "" : "0" + num;
    };

    if (!url) return;
    let date = new Date();
    var y = date.getFullYear(),
      m = formatNumber(date.getMonth() + 1),
      d = formatNumber(date.getDate()),
      h = formatNumber(date.getHours()),
      min = formatNumber(date.getMinutes()),
      ss = formatNumber(date.getSeconds());
    // let timeStamp = new Date(`${y}/${m}/${d} ${h}:${min}:${ss}`).getTime();
    let timeStamp = new Date(`${y}/${m}/${d}`).getTime();
    let param = encodeURIComponent(this.encrypt(y + m + d + "_" + timeStamp));
    const index = url.lastIndexOf("?param=");
    if (index > -1) {
      // 替换
      const str = url.substring(index + 1, url.length + 1);
      return url.replace(str, "param=" + param);
    }
    let returnUrl = url + "?param=" + param;
    return returnUrl;
  }
  // 处理文章详情中的图片链接
  public processArticleDetail(html: string): string {
    if (!html) return "";
    // 匹配所有img标签并替换src
    return html.replace(/src=["']([^"']+)["']/gi, (match, src) => {
      if (src.startsWith("https://image.longyixiu.com")) {
        const newSrc = this.getImageParam(src);
        return match.replace(src, newSrc);
      }
      return match;
    });
  }
}
